import React from "react";
import { PrivateRouteForTranscriptHistory } from "./PrivateRouteForTranscriptHistory";
import {
  Route,
  Redirect,
  withRouter
} from "react-router-dom";
import {useSelector} from 'react-redux';
import {useAuth} from 'oidc-react';
import  TranscriptHistory  from "../transcript-history/Transcript-history";
 export const PrivateRoute = ({ component: Component, ...rest }) => {
  const stateTransition = useSelector(state => state.stateTransition),
        canSignOut = useSelector(state => state.currentUser.canSignOut),
        auth = useAuth();

  let inactivityTime = function () { 
    let time;
    resetTimer();

    function resetTimer() { 
      clearTimeout(time); 
      time = setTimeout(newToken, 60000); 
    }

    async function newToken(){
      try {
        let userdata = await auth.userManager?.getUser();
        if(userdata && userdata.expired){
          console.log('User token expired, redirecting to home');
          localStorage.clear();
          await auth.userManager?.removeUser();
          window.location.href = `${process.env.PUBLIC_URL}/`;
        }
        else{
          console.log(userdata?.expired, 'not expired');
          resetTimer();
        }
      } catch (error) {
        console.error('Error checking user token:', error);
        localStorage.clear();
        window.location.href = `${process.env.PUBLIC_URL}/`;
      }
    }    
  }; 
  window.onload = function () { 
    inactivityTime(); 
  }

  window.history.pushState(null, "", window.location.href);
  window.onpopstate = function(){
    window.history.pushState(null, "", window.location.href);
  }
  
  const checkNav = (flag,cnfTestCase) => {
    switch(flag) {
        case 'Personal':
            return stateTransition.isTranscriptHistoryCrossed;    
        case 'Exam':
            return stateTransition.isPersonalInfoCrossed;
        case 'Institution':
            return stateTransition.isExamDetailsCrossed;
        case 'Review':
            return stateTransition.isInstitutionDetailsCrossed;
        case 'Terms':
          return stateTransition.isReviewAndConfirmCrossed;
        case 'AdyenForm':
          return stateTransition.isTermsCrossed;
        case 'Confirmation':
          return cnfTestCase?false:true;        
        case 'SignOut':
          return canSignOut; 
        default:
      }
  };
  
  return (
    <Route {...rest} render={(props) => (
     
         rest.value!=='History' ? (checkNav(rest.value,rest.confirmationTestCase)?<Component {...props} />:<Redirect to="/" />) :<PrivateRouteForTranscriptHistory path='/transcript-history' component={TranscriptHistory} />    
    )} />
  )
}

export default withRouter(PrivateRoute) 